import { graphql, useStaticQuery } from 'gatsby'

import {
  TRANSLATED_LANGUAGE_SET,
  supportLangFromPath
} from '../../../translation/languages'

// Which languages exist for the article at `slug`. Section-aware:
//  - /support/ : English is the bare canonical URL, translations are prefixed
//    (/support/<lang>/<app>/<slug>/); returns 'en' plus any translated locales.
//  - /new/ /whatsnew/ : unchanged — language is always an explicit path segment.
export const useGetLanguages = slug => {
  const data = useStaticQuery(graphql`
    query languageAlternatesQuery {
      whatsnew: allMdx(filter: { fields: { slug: { glob: "/whatsnew/**" } } }) {
        nodes {
          fields {
            slug
          }
        }
      }
      support: allMdx(filter: { fields: { slug: { glob: "/support/**" } } }) {
        nodes {
          fields {
            slug
          }
        }
      }
    }
  `)

  if (slug.startsWith('/support/')) {
    // Canonical key ignores the language segment, so an article and all its
    // translations share one key.
    const keyOf = s => {
      const parts = s.split('/').filter(Boolean).slice(1) // drop 'support'
      if (TRANSLATED_LANGUAGE_SET.has(parts[0])) parts.shift()
      return parts.join('/')
    }
    const key = keyOf(slug)
    return data.support.nodes
      .filter(({ fields: { slug: s } }) => keyOf(s) === key)
      .map(({ fields: { slug: s } }) => supportLangFromPath(s))
  }

  const [appname, endPath] = slug.split('/', 5).slice(3, 5)
  return data.whatsnew.nodes
    .filter(({ fields: { slug: s } }) => {
      const [a, e] = s.split('/', 5).slice(3, 5)
      return appname === a && endPath === e
    })
    .map(({ fields: { slug: s } }) => s.split('/', 5)[2])
}
